// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"9d083ec7","49":"6806189a","54":"2b36b1b0","348":"4897e9c4","453":"359a36be","495":"e01f3f1d","540":"d7d655a7","601":"ebb5dd9e","761":"91616f36","936":"f8174b50","995":"2c2820ae"}[chunkId] + ".chunk.js";
};